<div class="dialog">
  <div class="dialog-top">
    <h4 class="dialog-title">{{ data.title }}</h4>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-button"
      mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#0080FF" />
      <path opacity="0.8"
        d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
        fill="#0080FF" />
    </svg>
  </div>
  <mat-dialog-content class="dialog-flex">
    <form [formGroup]="form">
      <div class="dialog-box">

        <!-- Id -->
        <label class="mb-1 input-label mandatory"><span>*</span> {{ variables?.tenantIdField }}</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput formControlName="id" [readonly]="!isCreate" autocomplete="off">
          @if (isCreate && !(form.get('id')?.invalid && form.get('id')?.touched)) {
            <mat-hint>{{ variables?.tenantIdHint }}</mat-hint>
          }
          @if (form.get('id')?.invalid && form.get('id')?.touched) {
            <mat-error>
              @if (form.get('id')?.hasError('required')) {
                {{ variables?.mandatoryField }}
              } @else {
                {{ variables?.tenantIdInvalidHint }}
              }
            </mat-error>
          }
        </mat-form-field>

        <!-- Name -->
        <label class="mb-1 input-label mandatory"><span>*</span> {{ variables?.tenantNameField }}</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput formControlName="name" autocomplete="organization">
          @if (form.get('name')?.invalid && form.get('name')?.touched) {
            <mat-error>
              @if (form.get('name')?.hasError('required')) {
                {{ variables?.mandatoryField }}
              } @else {
                {{ variables?.tenantNameMaxHint }}
              }
            </mat-error>
          }
        </mat-form-field>

        <!-- Logo URL + preview -->
        <label class="mb-1 input-label">{{ variables?.tenantLogoField }}</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput formControlName="logo" autocomplete="off" [placeholder]="variables?.tenantLogoHint">
        </mat-form-field>
        @if (form.get('logo')?.value) {
          <div class="logo-preview">
            <img [src]="form.get('logo')?.value" [alt]="variables?.tenantLogoField" class="logo-preview-img">
          </div>
        }

        <!-- Colors -->
        <div class="color-row">
          <div class="color-field">
            <label class="mb-1 input-label">{{ variables?.tenantMainColorField }}</label>
            <div class="color-input-group">
              <input type="color"
                class="color-picker-native"
                [value]="mainColorPickerValue"
                (input)="onColorPickerChange('mainColor', $any($event.target).value)">
              <mat-form-field appearance="outline" class="color-text-field">
                <input matInput formControlName="mainColor" [placeholder]="'#RRGGBB'">
                @if (form.get('mainColor')?.invalid && form.get('mainColor')?.touched) {
                  <mat-error>{{ variables?.tenantColorInvalidHint }}</mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="color-field">
            <label class="mb-1 input-label">{{ variables?.tenantSecondaryColorField }}</label>
            <div class="color-input-group">
              <input type="color"
                class="color-picker-native"
                [value]="secondaryColorPickerValue"
                (input)="onColorPickerChange('secondaryColor', $any($event.target).value)">
              <mat-form-field appearance="outline" class="color-text-field">
                <input matInput formControlName="secondaryColor" [placeholder]="'#RRGGBB'">
                @if (form.get('secondaryColor')?.invalid && form.get('secondaryColor')?.touched) {
                  <mat-error>{{ variables?.tenantColorInvalidHint }}</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Maintenance % -->
        <label class="mb-1 input-label">{{ variables?.maintenancePct }}</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput type="number" formControlName="maintenancePct" min="0" max="100" step="0.01">
          @if (form.get('maintenancePct')?.invalid && form.get('maintenancePct')?.touched) {
            <mat-error>{{ variables?.mandatoryField }}</mat-error>
          }
        </mat-form-field>

        <!-- Login mode: when checked, the client logs in via SSO; otherwise via user/password. -->
        <mat-checkbox class="tenant-active-row" formControlName="useSso">{{ variables?.tenantUseSsoLabel }}</mat-checkbox>

        <!-- Email domain restriction for user registration -->
        <mat-checkbox class="tenant-active-row" formControlName="restrictEmailDomain">
          {{ variables?.tenantRestrictEmailDomainLabel }}
        </mat-checkbox>
        @if (form.get('restrictEmailDomain')?.value) {
          <label class="mb-1 input-label mandatory"><span>*</span> {{ variables?.tenantAllowedEmailDomainsField }}</label>
          <mat-form-field class="form-field" appearance="outline">
            <textarea matInput rows="3" formControlName="allowedEmailDomainsText"
              [placeholder]="variables?.tenantAllowedEmailDomainsHint"></textarea>
            @if (form.get('allowedEmailDomainsText')?.hasError('required') && form.get('allowedEmailDomainsText')?.touched) {
              <mat-error>{{ variables?.tenantEmailDomainsRequired }}</mat-error>
            }
            @if (form.get('allowedEmailDomainsText')?.hasError('invalidDomain') && form.get('allowedEmailDomainsText')?.touched) {
              <mat-error>{{ variables?.tenantEmailDomainInvalid }}</mat-error>
            }
          </mat-form-field>
        }

        <!-- Active toggle (edit mode only) -->
        @if (!isCreate) {
          <mat-checkbox class="tenant-active-row" formControlName="active">{{ variables?.active }}</mat-checkbox>
        }

      </div>
    </form>
    <div class="dialog-box-s">
      <mat-dialog-actions class="button-group">
        <app-button typeBtn="secondary" color="red" textColor="white" message="{{ variables?.goBack }}"
          mat-dialog-close></app-button>
        @if (!isView) {
          <app-button typeBtn="primary" (click)="save()" message="{{ variables?.save }}"></app-button>
        }
      </mat-dialog-actions>
    </div>
  </mat-dialog-content>
</div>
